import classNames from "classnames";
import background1 from "../../assets/images/background-login1.jpg";
import background2 from "../../assets/images/background-login1.jpg";
import background3 from "../../assets/images/background-login3.jpg";
import logo from "../../assets/images/full-logo.png";
import Image from "../../components/general/antd/image";
import LoginForm from "../../components/login/login-form";
import styles from "./styles.module.scss";
import { random } from "lodash";

interface Props {}

const LoginPage: React.FC<Props> = (props) => {
  const bgs = [
    background1,
    background2,
    background3,
    background1,
    background2,
    background3,
  ];
  return (
    <div
      className={styles.container}
      style={{
        backgroundImage: `url(${bgs[random(0, 5)]})`,
        textAlign: "center",
      }}
    >
      <div className={classNames("", styles.card)}>
        <Image
          preview={false}
          src={logo}
          alt={"logo"}
          style={{
            width: "100%",
            height: "30vh",
            marginBottom: "1rem",
            marginTop: "-1rem",
          }}
        />
        <div style={{ textAlign: "left" }}>
          <LoginForm />
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
